import { render, staticRenderFns } from "./ZcfgHome.vue?vue&type=template&id=5c84f5db&scoped=true"
import script from "./ZcfgHome.vue?vue&type=script&lang=js"
export * from "./ZcfgHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84f5db",
  null
  
)

export default component.exports